var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactModal from 'react-modal';
import RawHTML from '~/components/jsx-helpers/raw-html';
import cn from 'classnames';
import './dialog.scss';
function PutAway({ noTitle, onClick }) {
    return (React.createElement("button", { className: cn('put-away', { 'no-title-bar': noTitle }), hidden: !onClick, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(), "aria-label": "close" }, "\u00D7"));
}
export default function Dialog({ isOpen, title, onPutAway, children, className, closeOnOutsideClick = false, aria = title ? { labelledby: 'modal-dialog-title' } : { label: 'missing label' } }) {
    const overlayClassName = className ? `modal-overlay-${className}` : '';
    return (React.createElement(ReactModal, { isOpen: isOpen, className: cn('modal', className), overlayClassName: cn('modal-overlay', overlayClassName), bodyOpenClassName: "no-scroll-dialog", onRequestClose: onPutAway, shouldCloseOnOverlayClick: closeOnOutsideClick, shouldCloseOnEsc: closeOnOutsideClick, aria: aria },
        title ? (React.createElement("div", { className: "title-bar", id: "modal-dialog-title" },
            React.createElement(RawHTML, { Tag: "span", html: title }),
            React.createElement(PutAway, { onClick: onPutAway }))) : (React.createElement(PutAway, { noTitle: true, onClick: onPutAway })),
        React.createElement("div", { className: "main-region" }, children)));
}
export function useDialog(initiallyOpen = false) {
    const [showDialog, updateShowDialog] = React.useState(initiallyOpen);
    return React.useMemo(() => {
        const open = () => updateShowDialog(true);
        const close = () => updateShowDialog(false);
        function BoundDialog(_a) {
            var { title, children, modal = true, className, showPutAway = true, afterClose = () => null, aria } = _a, otherProps = __rest(_a, ["title", "children", "modal", "className", "showPutAway", "afterClose", "aria"]);
            const Modal = modal ? ReactModal : React.Fragment;
            const closeAndAfterClose = () => {
                close();
                afterClose();
            };
            return (React.createElement(Modal, Object.assign({ isOpen: showDialog, className: "modal", overlayClassName: "modal-overlay", bodyOpenClassName: "no-scroll-dialog" }, otherProps),
                React.createElement(Dialog, { title: title, className: className, isOpen: showDialog, onPutAway: showPutAway ? closeAndAfterClose : undefined, aria: aria }, children)));
        }
        return [BoundDialog, open, close, showDialog];
    }, [showDialog]);
}
